import { put, takeEvery } from 'redux-saga/effects'
import { createBrowserHistory } from 'history'

import { push } from 'connected-react-router'
import { appConfig } from '../../config'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import {
  FETCH_APPVERSION_INIT_ACTION,
  FETCH_APPVERSION_SUCCESS_ACTION,
  FETCH_APPVERSION_FAIL_ACTION,
  EDIT_APPVERSION_INIT_ACTION,
  EDIT_APPVERSION_SUCCESS_ACTION,
  EDIT_APPVERSION_FAIL_ACTION
} from './action'


var btoa = require('Base64').btoa
var history = createBrowserHistory()


function* fetchAppversionList() {

// console.log("app version saga work")

  try {
    const res = yield fetch(`${appConfig.ip}/appConfig`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        
      }
    })
    if (!res.ok) {
      let errJSON = {}
      try {
        errJSON = yield res.json()
      } catch { }
      throw Object.assign(res, errJSON)
    } else {

      const resJSON = yield res.json()
      // console.log("-----------------------app version",resJSON)

      yield put({
        type: FETCH_APPVERSION_SUCCESS_ACTION,
        payload: resJSON
      })
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_APPVERSION_FAIL_ACTION, error: err })
    } else {
    }
  }



}

function* editAppversion(value) {

  // console.log("app version edit saga work",value)

  const data={
    andrMinV:value.value.andrMinV,
    andrCurntV:value.value.andrCurntV,
    iosCurntV:value.value.iosCurntV,
    iosMinV:value.value.iosMinV,
    apiDown:value.value.apiDown,
    chemistDist:value.value.chemistDist,
    distributorDist:value.value.distributorDist
  }

 
  
  try {
    const token = localStorage.getItem('token')

    const res = yield fetch(`${appConfig.ip}/appConfig`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    })
    if (!res.ok) {
      let errJSON = {}
      try {
        errJSON = yield res.json()
      } catch { }
      throw Object.assign(res, errJSON)
    } else {

      const resJSON = yield res.json()
      yield toast.success("App Version updated successfully", {
        autoClose: 3000
      });
      yield put({
        type: EDIT_APPVERSION_SUCCESS_ACTION,
        payload: resJSON
      })

      yield put({
        type: FETCH_APPVERSION_INIT_ACTION,
      })
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: EDIT_APPVERSION_FAIL_ACTION, error: err })
    } else {
    }
  }
  
  
  }

export function* appversionActionWatcher() {
  yield takeEvery(FETCH_APPVERSION_INIT_ACTION, fetchAppversionList)
  yield takeEvery(EDIT_APPVERSION_INIT_ACTION, editAppversion)

}